// True while a media query matches, and follows it as the window changes.

import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  const subscribe = (onChange: () => void): (() => void) => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => {};
    const q = window.matchMedia(query);
    q.addEventListener("change", onChange);
    return () => q.removeEventListener("change", onChange);
  };
  const snapshot = (): boolean => (typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query).matches : false);
  return useSyncExternalStore(subscribe, snapshot, () => false);
}

/** A page wide enough to put the prep beside Breeze. */
export const WIDE_QUERY = "(min-width: 900px)";
